<div class="whatsapp-icon-container">
    <a target="_blank" [href]="'https://api.whatsapp.com/send?phone=+51'+configuration['WSP']">
        <img src="../../../assets/images/icons/whatsapp.svg">
        <div class="number-hover">+51{{configuration['WSP']}} <span class="arrow-pointer"></span></div>
    </a>
</div>